// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"650":"d6c63426","687":"719b8b35","787":"a20031b3"}[chunkId] + ".chunk.js";
};